import { Col, Grid, Row } from "@codat/orchard-ui";
import classNames from "classnames";
import React, { PropsWithChildren } from "react";

import styles from "./Page.module.css";

interface PageProps {
  className?: string;
}

const Page: React.FC<PropsWithChildren<PageProps>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={classNames(styles.page, className)}>
      <Grid fullWidth={true} {...props}>
        <Row>
          <Col size={12}>{children}</Col>
        </Row>
      </Grid>
    </div>
  );
};

export default Page;
